import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import useDashboardData from "../../../../hooks/useDashboard";
import ActiveUsersChart from "../../../components/ActiveUsersChart";
import Dashboardevents from "../../../components/dashboardevents/dashboardevents";
import LatestManual from "../../../components/LatestManual";
import NumbersChart from "../../../components/NumbersChart";
import SubscribersChart from "../../../components/SubscribersChart";
import classes from "./dashboard.module.css";

const Dashboard = () => {
   const { getDashboardData } = useDashboardData();
   const {
      dashboard: { dashboardResponse },
   } = useSelector((state) => state);

   useEffect(() => {
      const identifier = setTimeout(() => {
         getDashboardData();
      }, 1);

      return () => {
         clearTimeout(identifier);
      };
   }, [getDashboardData]);

   return (
      <div className={classes.mainContent}>
         <div className={classes.mainArea}>
            <div className={classes.stat_tiles}>
               <div className={`${classes.tile} ${classes.first_tile}`}>
                  <p>{dashboardResponse?.totalNumberOfUsers ?? 0}</p>
                  <span>Total Number of Users</span>
               </div>
               <div className={`${classes.tile} ${classes.second_tile}`}>
                  <p>{dashboardResponse?.totalNumberOfActiveUsers ?? 0}</p>
                  <span>Total Enabled Users</span>
               </div>
               <div className={`${classes.tile} ${classes.third_tile}`}>
                  <p>{dashboardResponse?.totalNumberOfMembers}</p>
                  <span>Total Number of registered users</span>
               </div>
            </div>
            <div className={classes.charts}>
               <div className={classes.TotalSubscribersChartContainer}>
                  <p>Total Number Of Subscribers</p>
                  <SubscribersChart />
               </div>

               <div className={classes.TotalMembersChartContainer}>
                  <p>Total Number Of registered users</p>
                  <NumbersChart />
               </div>

               <div className={classes.activeUserChartContainer}>
                  <p>Total Number Of Active Users</p>
                  <ActiveUsersChart />
               </div>
            </div>
         </div>
         <div className={classes.rightSide}>
            <Dashboardevents />
            <h4>Latest Manual</h4>
            <div className={classes.latestManual}>
               <LatestManual />
            </div>
         </div>
      </div>
   );
};

export default Dashboard;
